import i18next from "i18next";
import { compact, filter, findKey, includes, isEqual, last, map, max, min, orderBy, trim } from "lodash";
import { EVENT_NEW_SNACKBAR, EVENT_SCROLL_TO_MESSAGE, EVENT_REPLACE_TEXTAREA } from "../constants/events";
import { NotificationStorageOptionType, STORAGE_AUTHOR_HASH, STORAGE_CURRENT_ROOM, STORAGE_NOTIFICATION_OPTION, STORAGE_SET_ACTION_ID, STORAGE_USER_ID } from "../constants/localstorage";
import {
  CHANNEL_DELETE,
  CHANNEL_DELETE_MESSAGE,
  CHANNEL_GET_MESSAGES_STATS,
  CHANNEL_LEFT,
  CHANNEL_PIN_MESSAGE,
  CHANNEL_UPDATE_DRAFT,
  CHAT_CLEAR_MESSAGE,
  CHAT_DELETE,
  CHAT_DELETE_MESSAGE,
  CHAT_GET_ROOM,
  CHAT_SET_ACTION,
  CHAT_UPDATE_DRAFT,
  CHAT_UPDATE_STATUS,
  CLIENT_CHECK_INVITE_LINK,
  CLIENT_GET_ROOM,
  CLIENT_GET_ROOM_HISTORY,
  CLIENT_JOIN_BY_USERNAME,
  CLIENT_PIN_ROOM,
  CLIENT_RESOLVE_USERNAME,
  CLIENT_SUBSCRIBE_TO_ROOM,
  CLIENT_UNSUBSCRIBE_FROM_ROOM,
  GROUP_CLEAR_MESSAGE,
  GROUP_DELETE_MESSAGE,
  GROUP_LEFT,
  GROUP_PIN_MESSAGE,
  GROUP_SET_ACTION,
  GROUP_UPDATE_DRAFT,
  GROUP_UPDATE_STATUS,
  USER_CONTACTS_BLOCK,
  USER_CONTACTS_DELETE,
  USER_CONTACTS_UNBLOCK,
} from "../constants/methods";
import * as routes from "../constants/routes";
import { POPUP_BUY_CHARGE, POPUP_MAP, POPUP_PROFILE_IVAND, POPUP_RECEIPT, POPUP_ROOM, POPUP_ROOM_FORWARD, POPUP_ROOM_REPORT, POPUP_STICKER_ADD, ROUTE_MESSENGER } from "../constants/routes";
import { memoryHistory } from "../index";
import { FileDownload } from "../proto/FileDownload_pb";
import { ChannelRoom, ClientAction, Device, GroupRoom, RegisteredUser, Room, RoomDraft, RoomMessage, RoomMessageLog, RoomMessageStatus, RoomMessageType } from "../proto/Global_pb";
import store from "../store";
import {
  addMessagesLoader,
  clearRoomSelectedMessages,
  editMessagesLoader,
  editRoomMessage,
  markAsReadMessages,
  removeMessagesLoader,
  removeMessagesLoaders,
  removeRoomMedia,
  removeRoomMessages,
  goToMessage as goToMessageAction,
} from "../store/messages/actions";
import { setMessengerAttachment, setMessengerEditId, setMessengerPlayerAudio } from "../store/messenger/actions";
import { MessengerReplyIdType } from "../store/messenger/types";
import { addRooms, editRoom, removeRoom, removeRoomMembers, setCurrentRoom, setCurrentRoomExtra, setRoomAction } from "../store/rooms/actions";
import { downloadURL } from "./file";
import { FileGet } from "./fileHandler";
import { protoHandler } from "./proto";
import { getStorage, setStorage } from "./storage";
import { setUrlParam } from "./url";
import { focusOnInput, getRoomUsername, memorize, messageTypeHelper, parseEnter, parseMessage, windowOpen } from "./utils";
import { clearDraft, setDraftText } from "../store/draft/actions";
import { ClientResolveUsernameResponse } from "../proto/ClientResolveUsername_pb";
import { ActionTypes, AdditionalData, AdditionalType } from "../constants/globals";
import { getUser } from "./hooks";
import { sendMessage } from "./sendMessage";
import { REGEX_CHECK_URL, REGEX_CHECK_URL_HTTP, REGEX_INVITE_LINK, REGEX_RESOLVE_LINK, REGEX_TgADDR } from "../constants/regex";
import { agentDevice } from "./agent";
import { PAGINATION_CLIENT_GET_ROOM_HISTORY } from "../constants/pagination";
import { ClientGetRoomHistory } from "../proto/ClientGetRoomHistory_pb";
import { ErrorResponse } from "../proto/Error_pb";
import * as errors from "../constants/errors";
import forge from "node-forge";
import { RoomsType } from "../store/rooms/types";
import { StoryView } from "../proto/StoryGetOwnStoryViews_pb";
import navigationService from "./navigation";
import { ChannelGetMessagesStats } from "../proto/ChannelGetMessagesStats_pb";
import { protoRequestsObjectType } from "../constants/protoTable";
import { ClientSearchResponse } from "../proto/ClientSearch_pb";
import messageStyles from "../components/messenger/main/messages/message/styles.module.scss";
import AudioClass from "./audio-player";

export const goToRoom = (roomId?: Room.AsObject["id"] | undefined | null) => {
  const prevRoom: Room.AsObject = store.getState().rooms.rooms[`${store?.getState()?.rooms?.currentRoom}`];
  setTimeout(() => {
    if (roomId === prevRoom?.id) goToLastMessage();
    if (roomId !== undefined && roomId !== null) {
      setTimeout(() => {
        store.dispatch(
          editRoom({
            roomId,
            room: {
              firstUnreadMessage: undefined,
              unreadCount: undefined,
            },
          })
        );
      }, 10000);
      const nextRoom: Room.AsObject = store.getState().rooms.rooms[`${roomId}`];
      const userNameOrRoomId = getRoomUsername(nextRoom);

      store.dispatch(setCurrentRoom(roomId));
      setStorage(STORAGE_CURRENT_ROOM, roomId);

      memoryHistory.push({
        pathname: ROUTE_MESSENGER,
        search: `q=${userNameOrRoomId}`,
      });
    } else {
      goToMessenger();
    }
  });
  resetSelectedMessages();
};

export const goToLastMessage = () => {
  const roomId = store.getState().rooms.currentRoom;
  const room = store.getState().rooms.rooms[`${roomId}`];
  const messageId = room?.lastMessage?.messageId;

  if (roomId !== undefined && messageId !== undefined) {
    document.dispatchEvent(new CustomEvent(EVENT_SCROLL_TO_MESSAGE, { detail: { roomId, messageId } }));
  }
};

/**
 * @param username (Can Include @) eg : @channel
 * @Summary Check what's your passed username type then go to it
 */
export const goToRoomHelper = async (username?: string) => {
  console.log("[join] goToRoomHelper ", username);
  if (!username) return;
  if (username.includes("@")) username = username.replace("@", "");
  const { user, room, type }: ClientResolveUsernameResponse.AsObject = await protoHandler(CLIENT_RESOLVE_USERNAME, { username });
  console.log("[join]  ClientResolveUsernameResponse ", user, room);
  type === Room.Type.CHAT ? goToUserByUsername(user) : goToRoomByRoomName(room);
};

export const goToPopupHelper = async (username?: string, userId?: string) => {
  if (!username || !userId) return;
  if (username.includes("@")) username = username.replace("@", "");
  const finedUser: Room.AsObject | undefined = Object.values(store.getState().rooms.rooms).find((user) => user.chatRoomExtra?.peer?.id === userId);

  if (finedUser) {
    goToPopup(POPUP_ROOM, {
      roomId: finedUser.id,
      userId: userId,
      type: finedUser?.type,
      nameClick: true,
    });
  } else {
    const { user, type, room }: any = await protoHandler(CLIENT_RESOLVE_USERNAME, { username });
    if (user || room) {
      goToPopup(POPUP_ROOM, {
        roomId: room?.id,
        userId: user?.id,
        type: type,
        nameClick: true,
      });
    }
  }
};
export const goToRoomUserByDeepLink = memorize(async (query: RegisteredUser.AsObject["username"] | RegisteredUser.AsObject["id"], rooms: RoomsType) => {
  if ((!query && rooms !== undefined) || query === "undefined") return;
  Boolean(query[0] === "@") ? goToRoomHelper(query).then() : goToRoomByRoomId(query);
});

export const goToUserByUsername = (user: ClientResolveUsernameResponse.AsObject["user"]) => {
  if (!user) return;
  const rooms = store.getState().rooms.rooms;
  const userId = user.id;
  let findResult = filter(rooms, (chat) => chat.type === Room.Type.CHAT && chat.chatRoomExtra?.peer?.id === userId)[0];
  if (findResult) return goToRoom(findResult.id);

  protoHandler(CHAT_GET_ROOM, { peerId: userId }).then((res) => {
    store.dispatch(addRooms([res.room as Room.AsObject]));
    goToRoom(res.room?.id);
  });
};

export const goToRoomByRoomName = (room: ClientResolveUsernameResponse.AsObject["room"]) => {
  if (!room) return;

  const roomId = room.id;
  protoHandler(CLIENT_SUBSCRIBE_TO_ROOM, { roomId }).then();
  goToRoom(roomId);
};

export const internalLinkHandler = (text: string): any => {
  const tagUrl = text.match(text.match(/(http|https)/g) ? REGEX_CHECK_URL_HTTP : REGEX_CHECK_URL) as Array<string>;

  if (!tagUrl) return text;
  const path = tagUrl[1].split("/");
  console.log("internalLinkHandler", path[0]);
  let finalUrl = "";
  switch (path[0]) {
    case "join":
      finalUrl = "igap://join?invite=" + path[1];
      console.log("tagUrl join", tagUrl);
      break;
    case "addstickers":
      finalUrl = "igap://addstickers?set=" + path[1];
      console.log("tagUrl addstickers", tagUrl);
      break;
    default:
      if (path[1] && path[1].match(/^\d+$/)) {
        console.log("tagUrl if1", tagUrl);
        finalUrl = "igap://resolve?domain=" + path[0] + "&post=" + path[1];
      } else if (!path[1]) {
        console.log("tagUrl if2", tagUrl);
        const domainQuery = path[0].split("?");
        if (path[0] && !domainQuery[1]) {
          console.log("tagUrl if3", tagUrl);
          goToRoomHelper(path[0]).then();
          return undefined;
        } else {
          console.log("tagUrl else", tagUrl);
          finalUrl = "igap://resolve?domain=" + domainQuery[0] + (domainQuery[1] ? "&" + domainQuery[1] : "");
        }
      }
  }
  if (finalUrl === "") return text;
  // Remove Domain From FinalUrl , eg : igap://domain?join=.... => join=...
  return finalUrl.match(REGEX_TgADDR)![3] || "";
};

export const goToRoomByInviteToken = (token?: string) => {
  if (!token) return;
  const inviteToken: Array<string> | null = token.match(REGEX_INVITE_LINK) || token.match(REGEX_RESOLVE_LINK);
  if (!inviteToken) return windowOpen(token, "_blank");
  store.dispatch(setCurrentRoomExtra({ inviteToken: inviteToken[1] }));
  protoHandler(CLIENT_CHECK_INVITE_LINK, { inviteToken: inviteToken[1] })
    .then((res) => {
      if (!res.room) return;
      let alreadyNotJoined = store.getState().rooms.roomList.indexOf(res.room.id) === -1;
      if (alreadyNotJoined) {
        store.dispatch(addRooms([res.room]));
      }
      goToRoom(res.room.id);
    })
    .catch(() => {
      document.dispatchEvent(
        new CustomEvent(EVENT_NEW_SNACKBAR, {
          detail: {
            message: i18next.t("global.room_not_found"),
            options: { variant: "warning", autoHideDuration: 3000 },
          },
        })
      );
    });
};

export const handleSubscribe = async (subscribe: boolean = false, isPrivate: boolean) => {
  const currentRoom = store.getState().rooms.currentRoom;
  if (!subscribe && store.getState().rooms.currentRoomExtra.subscribed) {
    if (!isPrivate) await protoHandler(CLIENT_UNSUBSCRIBE_FROM_ROOM, { roomId: currentRoom });
    await store.dispatch(setCurrentRoomExtra({ subscribed: false, notJoined: false }));
  } else store.dispatch(setCurrentRoomExtra({ subscribed: subscribe, notJoined: subscribe, isPrivate }));
};

export const goToRoomByUserId = (userId: RegisteredUser.AsObject["id"]): void => {
  protoHandler(CHAT_GET_ROOM, { peerId: userId }).then((chatGetRoomResponse) => {
    goToRoom(chatGetRoomResponse.room?.id);
  });
};

export const goToRoomByRoomId = (roomId: Room.AsObject["id"]): void => {
  protoHandler(CLIENT_GET_ROOM, { roomId }).then((clientGetRoomResponse) => {
    goToRoom(clientGetRoomResponse.room?.id);
  });
};

export const goToMessenger = (): void => {
  resetSelectedMessages();
  store.dispatch(setCurrentRoom(undefined));
  memoryHistory.push(ROUTE_MESSENGER);
};

export const goToPopup = (popupName: keyof typeof routes, data?: any): void => {
  console.log("popup Name", popupName);
  const result = window.location.search.substr(1).split("&");
  console.log("result", result);
  for (let i = 0; i < result.length; i++) {
    if (result[i].startsWith("popup")) {
      result.splice(i, 1);
    }
  }
  result.push(`popup=${popupName}`);
  navigationService._navigation(
    { path: window.location.pathname, search: result.join("&") },
    {
      state: data,
    }
  );
};

export const goBackPopup = (): void => {
  // "YASHAR" marz haye code nevisi ro jabeja kardi
  if (agentDevice() === Device.MOBILE) {
    memoryHistory.back();
  } else {
    memoryHistory.back();
  }
};

export const clearAllPopups = (): void => {
  memoryHistory.push(setUrlParam(memoryHistory.location.pathname.replace(new RegExp("/$"), "") + memoryHistory.location.search, "popup", ""));
};

export const resetSelectedMessages = (): void => {
  store.dispatch(clearRoomSelectedMessages());
};

export const resetRepliedMessages = (): void => {
  store.dispatch(
    setDraftText({
      draft: {
        replyTo: "0",
      },
      roomId: store.getState().rooms.currentRoom as Room.AsObject["id"],
    })
  );
};

export const canSelectMessage = memorize((message?: RoomMessage.AsObject): boolean => {
  return message?.deleted === false && !includes([RoomMessageType.LOG, RoomMessageType.WALLET], message?.messageType);
});

export const canEditMessage = memorize((message?: RoomMessage.AsObject, room?: Room.AsObject): boolean => {
  return (
    room !== undefined &&
    message !== undefined &&
    !includes([RoomMessageType.STICKER, RoomMessageType.WALLET], message.messageType) &&
    {
      [Room.Type.CHAT]: isMyMessage(message),
      [Room.Type.GROUP]: isMyMessage(message),
      [Room.Type.CHANNEL]: isRoomOwner(room) || (isRoomAdmin(room) && room.permission?.editMessage === true),
    }[room.type]
  );
});

export const messageEdit = (message?: RoomMessage.AsObject): void => {
  if (message === undefined) return;
  store.dispatch(setMessengerEditId(message.messageId));
  document.dispatchEvent(new CustomEvent(EVENT_REPLACE_TEXTAREA, { detail: parseEnter(parseMessage(message.message, { parseLinks: false, parseEmoji: false, isReplace: true })) }));
  resetSelectedMessages();
  focusOnInput();
};
export const resetMessageEditId = (): void => {
  store.dispatch(setMessengerEditId("0"));
  resetSelectedMessages();
  const isEditing = store.getState().messenger.messengerEditId;
  isEditing && document.dispatchEvent(new CustomEvent(EVENT_REPLACE_TEXTAREA, { detail: "" }));
};

export const canReplyMessage = memorize((room?: Room.AsObject, message?: RoomMessage.AsObject): boolean => {
  return message !== undefined && !includes([RoomMessageType.LOG], message.messageType) && room?.readOnly === false;
});

export const messageReply = (messageId: MessengerReplyIdType, roomId: Room.AsObject["id"]): void => {
  focusOnInput();

  store.dispatch(
    setDraftText({
      draft: {
        replyTo: messageId,
      },
      roomId: roomId,
    })
  );
  resetSelectedMessages();
};

export const canCopyMessage = memorize((messages: Array<RoomMessage.AsObject>): boolean => {
  return messages.every((m) =>
    includes([RoomMessageType.TEXT, RoomMessageType.IMAGE_TEXT, RoomMessageType.VIDEO_TEXT, RoomMessageType.AUDIO_TEXT, RoomMessageType.GIF_TEXT, RoomMessageType.FILE_TEXT], m.messageType)
  );
});

export const messageCopy = (messages: Array<RoomMessage.AsObject>): void => {
  const texts: Array<string> = [];
  messages.forEach((message) => {
    const text = message.forwardFrom?.message || message.message;
    if (text.length > 0) texts.push(text);
  });
  navigator.clipboard.writeText(texts.join("\n")).then();
  resetSelectedMessages();
};

export const canForwardMessage = memorize((messages: Array<RoomMessage.AsObject>): boolean => {
  return messages.every((message) => (message.additionalData && JSON.parse(message.additionalData)?.giftId ? false : message.messageType !== RoomMessageType.LOG));
});

export const messageForward = (messagesId: Array<RoomMessage.AsObject["messageId"]>, roomId?: Room.AsObject["id"], isGift = false): void => {
  if (roomId !== undefined) {
    goToPopup(POPUP_ROOM_FORWARD, { selectedMessages: messagesId, roomId, isGift });
    resetSelectedMessages();
  }
  resetRepliedMessages();
};

export const canReportRoom = memorize((room?: Room.AsObject): boolean => {
  return room !== undefined && !isCloudRoom(room);
});

export const canReportMessage = memorize((message?: RoomMessage.AsObject): boolean => {
  return message !== undefined && !isMyMessage(message);
});

export const roomReport = (messageId?: RoomMessage.AsObject["messageId"], roomId?: Room.AsObject["id"]): void => {
  goToPopup(POPUP_ROOM_REPORT, { roomId, messageId });
};

export const canDownloadMessageAttachment = memorize((messageType?: RoomMessage.AsObject["messageType"]): boolean => {
  return !includes([RoomMessageType.TEXT, RoomMessageType.LOCATION, RoomMessageType.LOG, RoomMessageType.CONTACT, RoomMessageType.WALLET, RoomMessageType.STICKER], messageType);
});

export const messageDownloadAttachment = (message?: RoomMessage.AsObject): void => {
  if (message?.attachment !== undefined) {
    const fileHandler = new FileGet(message?.attachment, FileDownload.Selector.FILE);
    fileHandler.onFinish((url) => downloadURL(url, message?.attachment!.name));
    fileHandler.start();
  } else if (message?.attachment === undefined && message?.forwardFrom?.attachment) {
    const forwardedFileHandler = new FileGet(message?.forwardFrom?.attachment, FileDownload.Selector.FILE);
    forwardedFileHandler.onFinish((url) => downloadURL(url, message?.forwardFrom?.attachment!.name as string));
    forwardedFileHandler.start();
  }
};

export const canDeleteMessage = memorize((message?: RoomMessage.AsObject, room?: Room.AsObject): boolean => {
  return (
    isMyMessage(message) ||
    !!room?.chatRoomExtra?.peer ||
    (room?.type === Room.Type.CHANNEL && room.channelRoomExtra?.role === ChannelRoom.Role.ADMIN) ||
    (room?.type === Room.Type.GROUP && room.groupRoomExtra?.role === GroupRoom.Role.ADMIN) ||
    !!room?.permission?.deleteMessage
  );
});
export const canDragFile = memorize((room?: Room.AsObject): boolean => {
  return (
    (room?.type === Room.Type.CHANNEL && room.channelRoomExtra?.role === ChannelRoom.Role.ADMIN) ||
    room?.channelRoomExtra?.role === ChannelRoom.Role.OWNER ||
    room?.type === Room.Type.GROUP ||
    room?.type === Room.Type.CHAT
  );
});

export const canDeleteMessageBoth = memorize((messages: Array<RoomMessage.AsObject>, room?: Room.AsObject): boolean => {
  return !isCloudRoom(room) && messages.every((msg) => isMyMessage(msg) && canDeleteMessage(msg, room));
});

export const messageDelete = (messages: Array<RoomMessage.AsObject>, room?: Room.AsObject, deleteBoth?: boolean): void => {
  if (room === undefined) return;
  // console.log(
  //   "message delete id",
  //
  // );
  const arrayOfMessageId = messages.map((item) => {
    return item.messageId;
  });
  if (includes(arrayOfMessageId, store.getState().messenger.playerAudioMessageId.messageId)) {
    AudioClass.pause();
    AudioClass.changeAudio({ src: "" });
    store.dispatch(setMessengerPlayerAudio({ messageId: undefined, status: undefined }));
  }
  if (includes(arrayOfMessageId, store.getState()?.draft?.messageId?.replyTo)) store.dispatch(clearDraft);

  const actionId = {
    [Room.Type.CHANNEL]: CHANNEL_DELETE_MESSAGE,
    [Room.Type.GROUP]: GROUP_DELETE_MESSAGE,
    [Room.Type.CHAT]: CHAT_DELETE_MESSAGE,
  }[room.type];
  messages.forEach((message) => {
    protoHandler(actionId, {
      roomId: room.id,
      messageId: message.messageId,
      ...(actionId === CHAT_DELETE_MESSAGE ? { both: deleteBoth } : undefined),
    }).then();
  });
  resetSelectedMessages();
};

export const canCopyMessageLink = (room?: Room.AsObject): boolean => {
  return isPublicRoom(room);
};

export const messageCopyLink = (messages: Array<RoomMessage.AsObject["messageId"]>, room?: Room.AsObject): void => {
  if (room?.type === Room.Type.GROUP || room?.type === Room.Type.CHANNEL) {
    const message = store.getState().messages.messages[`${messages[0]}`];
    if (message.attachment?.publicUrl !== undefined) {
      navigator.clipboard.writeText(message.attachment?.publicUrl).then();
    }
    return;
  }
  const username = room?.channelRoomExtra?.publicExtra?.username || room?.groupRoomExtra?.publicExtra?.username;
  const linkAddresses = messages?.map((messageId) => "https://igap.net/" + username + "/" + messageId);
  if (username === undefined || linkAddresses === undefined) return;
  navigator.clipboard.writeText(linkAddresses.join("\n")).then();
  resetSelectedMessages();
};

export const canPinMessage = memorize((room?: Room.AsObject, messageId?: RoomMessage.AsObject["messageId"], unpin: boolean = false): boolean => {
  return (
    room !== undefined &&
    room?.readOnly === false &&
    includes([Room.Type.CHANNEL, Room.Type.GROUP], room?.type) &&
    room?.permission?.pinMessage === true &&
    (unpin ? room?.pinnedMessage?.messageId === messageId : room?.pinnedMessage?.messageId !== messageId)
  );
});

export const messagePin = (messageId?: RoomMessage.AsObject["messageId"], room?: Room.AsObject, unpin: boolean = false): void => {
  if (room === undefined || room.type === Room.Type.CHAT) return;
  const actionId = {
    [Room.Type.CHANNEL]: CHANNEL_PIN_MESSAGE,
    [Room.Type.GROUP]: GROUP_PIN_MESSAGE,
  }[room.type];
  protoHandler(actionId, {
    roomId: room.id,
    messageId: unpin ? undefined : messageId,
  }).then();
  resetSelectedMessages();
};

export const canBlockRoom = memorize((room?: Room.AsObject, unBlock: boolean = false): boolean => {
  return room?.type === Room.Type.CHAT && unBlock === store.getState().users.userBlocked.includes(`${room?.chatRoomExtra?.peer?.id}`);
});

export const blockRoom = (room?: Room.AsObject): void => {
  if (room?.chatRoomExtra?.peer?.id === undefined) return;
  protoHandler(USER_CONTACTS_BLOCK, { userId: room.chatRoomExtra.peer.id }).then();
};

export const unBlockRoom = (room?: Room.AsObject): void => {
  if (room?.chatRoomExtra?.peer?.id === undefined) return;
  protoHandler(USER_CONTACTS_UNBLOCK, { userId: room.chatRoomExtra.peer.id }).then();
};

export const canLeftRoom = memorize((room?: Room.AsObject): boolean => {
  return room !== undefined && room?.isParticipant === true && (room?.type === Room.Type.CHAT || isPrivateRoom(room) || (isPublicRoom(room) && !isRoomOwner(room)));
});

export const leftRoom = (room?: Room.AsObject): Promise<any> => {
  if (room === undefined) return Promise.resolve();
  if (room.type === Room.Type.CHANNEL && isRoomOwner(room)) {
    return protoHandler(CHANNEL_DELETE, { roomId: room.id });
  } else {
    return protoHandler(
      {
        [Room.Type.CHAT]: CHAT_DELETE,
        [Room.Type.GROUP]: GROUP_LEFT,
        [Room.Type.CHANNEL]: CHANNEL_LEFT,
      }[room.type],
      { roomId: room.id }
    );
  }
};

export const joinRoomByUsername = (room?: Room.AsObject): void => {
  if (room === undefined) return;
  let username;
  switch (room.type) {
    case Room.Type.CHANNEL:
      username = room.channelRoomExtra?.publicExtra?.username;
      break;
    case Room.Type.GROUP:
      username = room.groupRoomExtra?.publicExtra?.username;
      break;
  }
  protoHandler(CLIENT_JOIN_BY_USERNAME, { username }).then();
};

export const canClearRoomCache = (room?: Room.AsObject): boolean => {
  return room !== undefined;
};

export const handleClearRoomCache = (room?: Room.AsObject): void => {
  if (room === undefined) return;
  store.dispatch(setMessengerAttachment(undefined));
  store.dispatch(clearDraft(room.id));
  store.dispatch(setMessengerEditId(undefined));
  store.dispatch(clearRoomSelectedMessages());
  store.dispatch(removeMessagesLoaders(room.id));
  store.dispatch(removeRoom(room.id));
  store.dispatch(removeRoomMedia(room.id));
  store.dispatch(removeRoomMembers(room.id));
  store.dispatch(removeRoomMessages({ roomId: room.id }));
  goToMessenger();
  protoHandler(CLIENT_GET_ROOM, { roomId: room.id }).then();
};

export const canClearRoomHistory = memorize((room?: Room.AsObject): boolean => {
  return room !== undefined && room?.type !== Room.Type.CHANNEL;
});

export const handleClearHistory = (room?: Room.AsObject): void => {
  if (room === undefined || room.type === Room.Type.CHANNEL) return;
  const clearId = last(store.getState().messages.roomMessages[`${room.id}`]);
  protoHandler(
    {
      [Room.Type.CHAT]: CHAT_CLEAR_MESSAGE,
      [Room.Type.GROUP]: GROUP_CLEAR_MESSAGE,
    }[room.type],
    { roomId: room.id, clearId: clearId }
  ).then();
};

export const canPinRoom = (room?: Room.AsObject) => {
  return room?.pinId === "0";
};

export const pinRoom = (room?: Room.AsObject) => {
  protoHandler(CLIENT_PIN_ROOM, { pin: canPinRoom(room), roomId: room?.id }).then();
};

export const getLogMessageText = memorize(
  (params: {
    logType: RoomMessageLog.AsObject["type"] | undefined;
    roomType: Room.AsObject["type"] | undefined;
    authorName: RegisteredUser.AsObject["displayName"] | undefined;
    targetName: RegisteredUser.AsObject["displayName"] | undefined;
    pinnedMessage: RoomMessage.AsObject | undefined;
  }): string => {
    if (params.logType === undefined) return "";
    return i18next.t(`info_log.${params.logType}`, {
      authorName: params?.authorName,
      targetName: params.targetName,
      roomType: i18next.t(`room_types.${params.roomType}`),
      pinnedMessage: getMessageText(params.pinnedMessage).replace(/[\r\n]+/g, " "),
    });
  }
);

export const getMessageText = memorize((message?: RoomMessage.AsObject): string => {
  let text = message?.message || message?.forwardFrom?.message || message?.replyTo?.message || "";
  if (message?.forwardFrom) {
    if (messageTypeHelper(message.forwardFrom.messageType).isHaveText()) {
      text = `${message.forwardFrom.message}`;
    } else {
      text = i18next.t(`message_types.${message?.forwardFrom?.messageType}`);
    }
  } else if (text.length === 0 && message?.messageType !== undefined) {
    text = i18next.t(`message_types.${message.messageType}`);
  }
  return trim(text) || "";
});

export const isPublicRoom = memorize((room?: Room.AsObject): boolean => {
  return (
    (room?.type === Room.Type.GROUP && room?.groupRoomExtra?.type === GroupRoom.Type.PUBLIC_ROOM) || (room?.type === Room.Type.CHANNEL && room?.channelRoomExtra?.type === ChannelRoom.Type.PUBLIC_ROOM)
  );
});

export const isPrivateRoom = memorize((room?: Room.AsObject): boolean => {
  return (
    (room?.type === Room.Type.GROUP && room?.groupRoomExtra?.type === GroupRoom.Type.PRIVATE_ROOM) ||
    (room?.type === Room.Type.CHANNEL && room?.channelRoomExtra?.type === ChannelRoom.Type.PRIVATE_ROOM)
  );
});

export const isRoomOwner = memorize((room?: Room.AsObject): boolean => {
  return (room?.type === Room.Type.GROUP && room?.groupRoomExtra?.role === GroupRoom.Role.OWNER) || (room?.type === Room.Type.CHANNEL && room?.channelRoomExtra?.role === ChannelRoom.Role.OWNER);
});

export const isRoomAdmin = memorize((room?: Room.AsObject): boolean => {
  return (room?.type === Room.Type.GROUP && room?.groupRoomExtra?.role === GroupRoom.Role.ADMIN) || (room?.type === Room.Type.CHANNEL && room?.channelRoomExtra?.role === ChannelRoom.Role.ADMIN);
});

export const isRoomMember = memorize((room?: Room.AsObject): boolean => {
  return (room?.type === Room.Type.GROUP && room?.groupRoomExtra?.role === GroupRoom.Role.MEMBER) || (room?.type === Room.Type.CHANNEL && room?.channelRoomExtra?.role === ChannelRoom.Role.MEMBER);
});

export const isMyMessage = memorize((message?: RoomMessage.AsObject): boolean => {
  return message?.author?.hash === getStorage(STORAGE_AUTHOR_HASH) || message?.author?.user?.userId === getStorage(STORAGE_USER_ID);
});

export const isCloudRoom = memorize((room?: Room.AsObject): boolean => {
  return room?.chatRoomExtra?.peer?.id === getStorage(STORAGE_USER_ID);
});

export const canInviteByRoomLink = memorize((room?: Room.AsObject): boolean => {
  return room?.type === Room.Type.CHAT && isRoomOwner(room) && isPrivateRoom(room);
});

export const playSound = (volume?: number) => {
  new Audio(require("../assets/audio/send_message_sound.mp3").default).play().then();
};

export const sendMessageNotification = (roomId: Room.AsObject["id"], room: Room.AsObject, message: RoomMessage.AsObject) => {
  const playSendMessageSound = store.getState().messenger.chatSettings.play_message_sound_in_chat;
  const options = getStorage(STORAGE_NOTIFICATION_OPTION) as NotificationStorageOptionType;
  if (document.visibilityState === "hidden" && !room?.roomMute && !isMyMessage(message)) {
    const notification = new Notification(room?.title || "", {
      body: options.preview ? getMessageText(message) : i18next.t("notification_popup.default_message"),
      icon: require("../assets/img/logo-circle.png").default,
      silent: !options.sound,
    });

    notification.onclick = () => {
      window.focus();
      document.dispatchEvent(
        new CustomEvent(EVENT_SCROLL_TO_MESSAGE, {
          detail: {
            roomId,
            messageId: message.messageId,
          },
        })
      );
    };
  }
  if (isMyMessage(message) && playSendMessageSound) {
    playSound();
  }
};

export const canCall = (room?: Room.AsObject) => {
  return room?.type === Room.Type.CHAT;
};

type SendDraftRoomArg = Pick<Room.AsObject, "type" | "id"> & { draft: Omit<RoomDraft.AsObject, "draftTime"> };
export const sendDraft = memorize((room?: SendDraftRoomArg, permission?: Room.AsObject["permission"]): Promise<void> => {
  return new Promise((resolve) => {
    if (!room || (permission && room.type !== Room.Type.CHAT && !permission.postMessage)) return resolve();
    const actionId = {
      [Room.Type.CHANNEL]: CHANNEL_UPDATE_DRAFT,
      [Room.Type.GROUP]: GROUP_UPDATE_DRAFT,
      [Room.Type.CHAT]: CHAT_UPDATE_DRAFT,
    }[room.type || 0];
    protoHandler(actionId, {
      roomId: room.id,
      //@ts-ignore
      draft: room.draft || store.getState().draft[`${store?.getState()?.rooms?.currentRoom}`],
    }).then(() => resolve);
  });
});

export const searchUsersAndRoomInCache = (query: string): { contacts: RegisteredUser.AsObject[]; users: RegisteredUser.AsObject[]; channels: Room.AsObject[]; groups: Room.AsObject[] } => {
  const userInStore = store.getState().users.users;
  const roomInStore = store.getState().rooms.rooms;

  let contacts: Array<RegisteredUser.AsObject> = [];
  let users: Array<RegisteredUser.AsObject> = [];
  let channels: Array<Room.AsObject> = [];
  let groups: Array<Room.AsObject> = [];

  //Contacts and Users
  Object.keys(userInStore).forEach((userId) => {
    const user = userInStore[userId];

    if (user.username?.toLowerCase().includes(query) || user.displayName?.toLowerCase().includes(query)) {
      if (user.mutual) {
        contacts.push(user);
      } else {
        users.push(user);
      }
    }
  });

  //Channels and Groups
  Object.keys(roomInStore).forEach((roomId) => {
    const room = roomInStore[roomId];

    if (room.title?.toLowerCase().includes(query) || room.channelRoomExtra?.publicExtra?.username.includes(query)) {
      if (isChannel(room)) {
        channels.push(room);
      } else if (isGroup(room)) {
        groups.push(room);
      }
    }
  });

  return { contacts, users, channels, groups };
};

export const filterContacts = (query: string, contactsInStore: { [key: string]: RegisteredUser.AsObject }): Array<RegisteredUser.AsObject> => {
  let contacts: Array<RegisteredUser.AsObject> = [];

  Object.keys(contactsInStore).forEach((contactId) => {
    const contact = contactsInStore[contactId];

    if (contact.displayName.toLowerCase().includes(query) || contact.username.toLowerCase().includes(query)) contacts.push(contactsInStore[contactId]);
  });

  return contacts;
};

export const deleteContact = (memberId: string | undefined) => {
  if (memberId) {
    //  TODO FixBeforePush
    // getUser(memberId).then((response) => {
    //   protoHandler(USER_CONTACTS_DELETE, { phone: response?.user?.phone }).then();
    // });
  }
};

export const canDeleteContact = (memberId: string | undefined) => {
  return memberId && true;
};

export const EditContact = (memberId: string | undefined) => {
  goToPopup("POPUP_EDIT_CONTACT", { memberId });
};

export const canEditContact = (memberId: string | undefined) => {
  return memberId && true;
};

export const onBotButtonClick = (data: AdditionalData, user?: RegisteredUser.AsObject) => {
  let roomId = store.getState().rooms.currentRoom;
  switch (data.actionType) {
    case ActionTypes.BUTTON_ACTION_PAY_DIRECT:
      return goToPopup(POPUP_RECEIPT, { token: data.value.token });
    case ActionTypes.BUTTON_ACTION_USERNAME_LINK:
      return goToRoomHelper(data.value);
    case ActionTypes.BUTTON_ACTION_WEBVIEW_LINK:
    case ActionTypes.BUTTON_ACTION_WEB_LINK:
      return window.open(data.value, "_blank");
    case ActionTypes.BUTTON_ACTION_JOIN_LINK:
      return goToRoomByInviteToken(internalLinkHandler(data.value));
    case ActionTypes.BUTTON_ACTION_STICKER_SHOP:
      return goToPopup(POPUP_STICKER_ADD);
    case ActionTypes.BUTTON_ACTION_REQUEST_LOCATION:
      return goToPopup(POPUP_MAP);
    case ActionTypes.BUTTON_ACTION_IVAN:
      return goToPopup(POPUP_PROFILE_IVAND);
    case ActionTypes.BUTTON_ACTION_TOPUP_MENU:
      return goToPopup(POPUP_BUY_CHARGE);
    case ActionTypes.BUTTON_ACTION_IVANDSCORE:
      return goToPopup(POPUP_PROFILE_IVAND);
    default:
      if (data.actionType == ActionTypes.BUTTON_ACTION_REQUEST_PHONE) data["value"] = user?.phone;
      sendMessage(
        {
          additionalData: JSON.stringify(data),
          additionalType: AdditionalType.BUTTON_CLICK_ACTION,
          message: data?.label,
        },
        roomId!
      ).then();
  }
};

export const setIsTypingUser = (isTyping: boolean, roomId?: Room.AsObject["id"], type?: Room.AsObject["type"], randomActionId?: number) => {
  if (!roomId) return;

  setStorage(STORAGE_SET_ACTION_ID, randomActionId);
  protoHandler(type === Room.Type.CHAT ? CHAT_SET_ACTION : GROUP_SET_ACTION, {
    roomId,
    action: isTyping ? ClientAction.TYPING : ClientAction.CANCEL,
    actionId: randomActionId,
  }).then();
  setTimeout(() => {
    if (roomId)
      store.dispatch(
        setRoomAction({
          roomId,
          userId: [],
          action: ClientAction.CANCEL,
        })
      );
  }, 30000);
};

export const isSelectingText = () => {
  return window.getSelection() !== null && window.getSelection && window.getSelection()?.type === "Range";
};

export const getUsernameOrRoomId = (room?: Room.AsObject): Room.AsObject["id"] | RegisteredUser.AsObject["username"] | void => {
  if (!room) return;

  const username = room.channelRoomExtra?.publicExtra?.username || room.groupRoomExtra?.publicExtra?.username || room.chatRoomExtra?.peer?.username;
  return username ? `@${username}` : room.id;
};
export const hasEditorPermission = (roomId: Room.AsObject["id"] | undefined) => {
  const room = store.getState().rooms.rooms[`${roomId}`];
  if (!room) return false;
  if (room.type === Room.Type.CHANNEL) {
    return room.permission?.postMessage || false;
  }
  if (room.type === Room.Type.CHAT) {
    return true;
  }
  const groupRoomExtra = room?.groupRoomExtra;
  if (!groupRoomExtra) return true;
  return groupRoomExtra?.roomRights?.sendText || groupRoomExtra?.role === GroupRoom.Role.ADMIN || groupRoomExtra?.role === GroupRoom.Role.OWNER;
};

export const isHigap = (roomId?: Room.AsObject["id"]) => {
  if (!roomId) return false;
  const chatRoomExtra = store.getState().rooms.rooms[roomId]?.chatRoomExtra || undefined;
  if (!chatRoomExtra) return false;
  return chatRoomExtra.peer?.id === "2297310";
};

export const isBot = (room: Room.AsObject): boolean => room?.chatRoomExtra?.peer?.bot || false;

export const isChannel = (room: Room.AsObject): boolean => room?.type === Room.Type.CHANNEL;

export const isGroup = (room: Room.AsObject): boolean => room?.type === Room.Type.GROUP;

export const loadMoreMessages = (
  direction: ClientGetRoomHistory.AsObject["direction"],
  fromMessageId: RoomMessage.AsObject["messageId"],
  roomId: Room.AsObject["id"],
  setMessageLoader: boolean = true
): Promise<RoomMessage.AsObject["messageId"]> => {
  return new Promise((resolve, reject) => {
    if (setMessageLoader)
      store.dispatch(
        editMessagesLoader({
          roomId: roomId,
          fromMessageId: fromMessageId,
          direction: direction,
          status: "processing",
        })
      );

    protoHandler(CLIENT_GET_ROOM_HISTORY, {
      roomId: roomId,
      firstMessageId: fromMessageId,
      direction,
      limit: PAGINATION_CLIENT_GET_ROOM_HISTORY,
    })
      .then((clientGetRoomHistoryResponse) => {
        const toMessageId =
          direction === ClientGetRoomHistory.Direction.UP ? min(map(clientGetRoomHistoryResponse.messageList, "messageId")) : max(map(clientGetRoomHistoryResponse.messageList, "messageId"));
        if (roomId !== undefined && toMessageId !== undefined && fromMessageId !== undefined) {
          if (setMessageLoader)
            store.dispatch(
              addMessagesLoader({
                roomId: roomId,
                direction: [direction],
                fromMessageId: fromMessageId,
                toMessageId: toMessageId,
              })
            );
        }
        return resolve(fromMessageId);
      })
      .catch((error: ErrorResponse.AsObject) => {
        if (roomId !== undefined && error.majorCode === errors.ERROR_CLIENT_GET_ROOM_HISTORY_NOT_FOUND) {
          if (setMessageLoader) store.dispatch(removeMessagesLoader({ roomId: roomId, fromMessageId, direction }));
        }
        return reject(error);
      });
  });
};

export const handleMarkAsRead = (messageId: RoomMessage.AsObject["messageId"], roomId?: Room.AsObject["id"], isFirstUnreadMessage: boolean = false) => {
  const message = store.getState().messages.messages[`${messageId}`];
  const roomType = store.getState().rooms.rooms[`${roomId}`]?.type;
  if (message?.deleted === false && !isMyMessage(message) && !includes([RoomMessageStatus.SEEN, RoomMessageStatus.LISTENED], message?.status)) {
    let promise: Promise<any>;

    promise = protoHandler(roomType === Room.Type.CHAT ? CHAT_UPDATE_STATUS : GROUP_UPDATE_STATUS, {
      messageId: messageId,
      roomId: roomId,
      status: RoomMessageStatus.SEEN,
    });

    promise.catch(() => {
      store.dispatch(
        markAsReadMessages({
          roomId: roomId!,
          messageId: messageId,
          updaterAuthorHash: "",
        })
      );
    });
  }
};

export const channelMarkAsRead = memorize((messageIds: Array<RoomMessage.AsObject["messageId"]>, roomId?: Room.AsObject["id"], isFirstUnreadMessage: boolean = false): Promise<unknown> => {
  console.log("channelMarkAsRead", messageIds, roomId, isFirstUnreadMessage);
  if (isFirstUnreadMessage && roomId) {
    setTimeout(() => {
      store.dispatch(
        editRoom({
          roomId,
          room: {
            firstUnreadMessage: undefined,
          },
        })
      );
    }, 10000);
  }
  const messageIdInfoList: ChannelGetMessagesStats.AsObject["messageIdInfoList"] = compact(
    messageIds.map((messageId) => {
      const message = store.getState().messages.messages[`${messageId}`];
      if (message?.deleted === false && !isMyMessage(message) && !includes([RoomMessageStatus.SEEN, RoomMessageStatus.LISTENED], message?.status)) {
        return { messageId, documentId: message.documentId };
      }
    })
  );
  if (!messageIdInfoList.length) return Promise.resolve();

  return protoHandler(CHANNEL_GET_MESSAGES_STATS, {
    roomId,
    messageIdInfoList,
  });
});

export const generatePublicKey = () => {
  const key = forge.pki.rsa.generateKeyPair(1024);
  const generatedKey = forge.pki.publicKeyToPem(key.publicKey).replace(/(?:\r\n|\r|\n)/g, "\\n");
  return {
    key,
    generatedKey,
  };
};

export const getDataFromDiscoveryLink = (link?: string, disoveryItems?: any) => {
  if (!link && !disoveryItems) return undefined;
  const id = link?.substr(17);
  let returned;
  if (id !== undefined) {
    disoveryItems?.forEach((items: any) => {
      const find = items[items.discoveryfieldsList?.length ? "discoveryfieldsList" : "pollfieldsList"]?.filter((item2: any) => item2.id === +id);
      if (find.length > 0) {
        returned = find[0];
        return;
      }
    });
  }

  return returned;
};

export const getStory = (userId: RegisteredUser.AsObject["id"]) => {
  return store.getState().stories.stories[userId];
};

export const getViewedUsers = (usersViews?: Array<StoryView.AsObject>): Array<RegisteredUser.AsObject> => {
  const users: Array<RegisteredUser.AsObject> = [];
  if (usersViews) usersViews.forEach((view) => users.push({ ...store.getState().users.users[view.userId], ...view }));
  return users;
};

export const getRoomIdByUserId = memorize(async (userId: RegisteredUser.AsObject["id"]): Promise<Room.AsObject["id"] | undefined> => {
  const rooms = store.getState().rooms.rooms;
  const roomId = findKey(rooms, (room: Room.AsObject) => room.chatRoomExtra?.peer?.id === userId);
  if (roomId !== undefined) return roomId;
  else return (await protoHandler(CHAT_GET_ROOM, { peerId: userId })).room?.id;
});

export const seenChannel = (roomId: Room.AsObject["id"]) => {
  store.dispatch(
    editRoom({
      roomId,
      room: {
        unreadCount: 0,
      },
    })
  );
};

export const seenMessage = (roomId: Room.AsObject["id"], messageId: RoomMessage.AsObject["messageId"]) => {
  store.dispatch(
    markAsReadMessages({
      roomId,
      messageId,
      updaterAuthorHash: "",
    })
  );
  editRoomMessage({
    messageId,
    message: {
      status: RoomMessageStatus.SEEN,
    },
  });
};

export const sortForwardList = (rooms: RoomsType) =>
  orderBy(
    rooms,
    [
      "pinId",
      (o) => {
        return o?.lastMessage?.updateTime || o?.lastMessage?.createTime;
      },
      "draft.message",
    ],
    ["desc", "desc", "desc"]
  );

interface stateObjType {
  [k: string]: { currentVal: any; protoKey: keyof protoRequestsObjectType; payloadObj: Object; onThen?: (res: any) => any; onCatch?: (e: any) => any };
}

type propsToCheckType<T> = {
  [k in keyof T]: any;
};

export const updateIfChange = <T>(stateObj: T & stateObjType, propsToCheck: propsToCheckType<T>) => {
  for (const key in propsToCheck) {
    if (Object.prototype.hasOwnProperty.call(propsToCheck, key)) {
      const element = propsToCheck[key];

      const { currentVal, protoKey, payloadObj, onThen, onCatch } = stateObj[key];

      if (!isEqual(currentVal, element)) {
        protoHandler(protoKey, payloadObj)
          .then((res) => {
            onThen && onThen(res);
          })
          .catch((e) => {
            onCatch && onCatch(e);
          });
      }
    }
  }
};

interface InfoSearchType {
  users: Array<RegisteredUser.AsObject>;
  channels: Array<Room.AsObject>;
  groups: Array<Room.AsObject>;
}
export const shapeSearchInfo = (rawData: ClientSearchResponse.Info.AsObject[]): { global: InfoSearchType; mine: InfoSearchType } => {
  const mineSearchInfo: InfoSearchType = {
    users: [],
    channels: [],
    groups: [],
  };
  const globalSearchInfo: InfoSearchType = {
    users: [],
    channels: [],
    groups: [],
  };

  rawData.forEach((info) => {
    let categoryInfoTarget: typeof mineSearchInfo | typeof globalSearchInfo = info.category === 0 ? mineSearchInfo : globalSearchInfo;

    if (info.type === 0 && !!info.user) {
      categoryInfoTarget.users.push(info.user);
    } else if (info.type === 1 && !!info.room) {
      categoryInfoTarget[isChannel(info.room) ? "channels" : "groups"].push(info.room);
    }
  });

  return { global: globalSearchInfo, mine: mineSearchInfo };
};

export const scrollToMessage = (
  messageId: RoomMessage.AsObject["messageId"],
  roomId: Room.AsObject["id"],
  options: { retryLimit?: number; hasPriority?: boolean } = { retryLimit: 3, hasPriority: false }
) => {
  const { retryLimit = 3, hasPriority = false } = options;

  const el = document.querySelector(`[data-message-id="${messageId}"]`);
  const scrolledMessage = store.getState().messages.scrolledMessage[roomId];
  if (scrolledMessage?.userCalled) {
    messageId = scrolledMessage.messageId;
  }
  if (el === null) {
    retryLimit > 0 && scrollToMessage(messageId, roomId, { hasPriority, retryLimit: retryLimit - 1 });
  } else if (roomId === store.getState().rooms.currentRoom) {
    el.scrollIntoView();
    if (hasPriority) el.classList.add(`${messageStyles["scrolled"]}`);

    if (messageId !== undefined && messageId === store.getState().rooms.rooms[`${roomId}`]?.firstUnreadMessage?.messageId) {
      editRoom({
        roomId: roomId,
        room: { firstUnreadMessage: undefined },
      });
    }
  }
};

export const goToMessage = async (messageId: RoomMessage.AsObject["messageId"], roomId: Room.AsObject["id"], hasPriority = false): Promise<void> => {
  store.dispatch(goToMessageAction({ messageId, roomId, hasPriority }));
};

export const isChatActive = (): boolean => {
  const currentRoomId = store.getState().rooms.currentRoom;

  // if currentRoomId is undefined it means there is no chat on the screen
  return !!currentRoomId;
};
